import { COOKIE_NAMES } from './constants';
import { storeInCookie } from './cookies';

export const FINGERPRINT_COOKIE_KEY = 'fingerprintV2';

const FINGERPRINT_TIMEOUT_MS = 3000;

export const getBrowserFingerprint = (): Promise<string> =>
  new Promise((resolve) => {
    const timeout = setTimeout(() => resolve(''), FINGERPRINT_TIMEOUT_MS);

    import('fingerprintjs2')
      .then(({ default: Fingerprint2 }) => {
        Fingerprint2.getV18({}, (hash) => {
          clearTimeout(timeout);
          storeInCookie(COOKIE_NAMES.KAZUMO, FINGERPRINT_COOKIE_KEY, hash ?? '');
          resolve(hash ?? '');
        });
      })
      .catch(() => {
        clearTimeout(timeout);
        console.warn('Loading fingerprintjs2 failed');
        resolve('');
      });
  });
